import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { multiProductUpdateAction } from '../../../redux/actions/productActions';

const SelectedProductButtons = ({ selectedProdcuts, setSelectedProdcuts, user }) => {




    const {  message } = useSelector((state) => state.multiProducts)


    const dispatch = useDispatch();


    const [showPopup, setShowPopup] = useState(false);
    const [actionToPerform, setActionToPerform] = useState('');

    const [popupHeading, setpopupHeading] = useState('');
    const [popupPara, setpopupPara] = useState('');








    const handleReserve = () => {





        if (actionToPerform === 'SYSTEM_CANCELLED' || actionToPerform === 'PAUSED' || actionToPerform === 'ACTIVE' || actionToPerform === 'INACTIVE' || actionToPerform === 'DELETED') {

            dispatch(multiProductUpdateAction({ product_ids: selectedProdcuts, status: actionToPerform }))
        }

        setShowPopup(false)


    }


    const handleCancel = (statusVal) => {
        setShowPopup(true);


        if (statusVal === "SYSTEM_CANCELLED") {
            setpopupHeading('Cancel Product')
            setpopupPara(' Are you sure you want to cancel these products? This action cannot be undone.')
            setActionToPerform('SYSTEM_CANCELLED')

        } else if (statusVal === "PAUSED") {

            setpopupHeading('Pause Product')
            setpopupPara(' Are you sure you want to pause these products? Buyers Cannot place orders on this product until it is unpaused.')
            setActionToPerform('PAUSED')

        } else if (statusVal === "ACTIVE") {
            setpopupHeading('Active Product')
            setpopupPara(' Are you sure you want to activate these products? Buyers Can place orders on this product.')
            setActionToPerform('ACTIVE')

        } else if (statusVal === "INACTIVE") {
            setpopupHeading('Deactivate Product')
            setpopupPara(' Are you sure you want to deactivate these products? This action cannot be undone.')
            setActionToPerform('INACTIVE')
        } else if (statusVal === "DELETED") {
            setpopupHeading('Delete Products')
            setpopupPara(' Are you sure you want to completely delete these products? This action cannot be undone.')
            setActionToPerform('DELETED')
        }


    }




    useEffect(() => {
        if (message) {
            setActionToPerform('');
            setSelectedProdcuts([]);
        }
    }, [message, setSelectedProdcuts])

    return (
        <Fragment>
            <div className={`flex`}>
                <div className="flex-center w-fit text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax] flex-center gap-[0.5vmax]  rounded-b-2xl mt-[-0.2vmax]" >

                    <div className="flex-center px-[0.5vmax] flex-[2.5] text-[#4c4c5c] uppercase text-[1.3vmax] lg:text-[0.8vmax] flex-center gap-[0.5vmax]" >


                        {(user?.role === "ADMIN" || user?.role === "SUPER_ADMIN")
                            &&
                            <button className={`px-[1.2vmax] py-[0.6vmax] flex items-center gap-2 bg-red-50 text-red-600 rounded-xl hover:bg-red-100 transition-all border border-red-200 font-bold text-[0.9vmax]`}
                                onClick={() => handleCancel("SYSTEM_CANCELLED")}
                            >
                                <i className="fa-solid fa-ban"></i>
                                Cancel ({selectedProdcuts?.length})
                            </button>
                        }
                        <button className={`px-[1.2vmax] py-[0.6vmax] flex items-center gap-2 bg-amber-50 text-amber-600 rounded-xl hover:bg-amber-100 transition-all border border-amber-200 font-bold text-[0.9vmax]`}
                            onClick={() => handleCancel('PAUSED')}
                        >
                            <i className="fa-solid fa-pause"></i>
                            Stop ({selectedProdcuts?.length})
                        </button>
                        <button className={`px-[1.2vmax] py-[0.6vmax] flex items-center gap-2 bg-emerald-50 text-emerald-600 rounded-xl hover:bg-emerald-100 transition-all border border-emerald-200 font-bold text-[0.9vmax]`}
                            onClick={() => handleCancel('ACTIVE')}
                        >
                            <i className="fa-solid fa-play"></i>
                            Resume ({selectedProdcuts?.length})
                        </button>
                        {user?.role !== "PM"
                            &&
                            <button className={`px-[1.2vmax] py-[0.6vmax] flex items-center gap-2 bg-purple-50 text-purple-600 rounded-xl hover:bg-purple-100 transition-all border border-purple-200 font-bold text-[0.9vmax]`}
                                onClick={() => handleCancel('INACTIVE')}
                            >
                                <i className="fa-solid fa-eye-slash"></i>
                                Mark Inactive ({selectedProdcuts?.length})
                            </button>
                        }
                        {(user?.role === "ADMIN" || user?.role === "SUPER_ADMIN" || user?.role === "PMM") &&
                            <button className={`px-[1.2vmax] py-[0.6vmax] flex items-center gap-2 bg-red-100 text-red-600 rounded-xl hover:bg-red-200 transition-all border border-red-300 font-bold text-[0.9vmax]`}
                                onClick={() => handleCancel('DELETED')}
                            >
                                <i className="fa-solid fa-trash-can"></i>
                                Delete ({selectedProdcuts?.length})
                            </button>
                        }

                    </div>
                </div>
            </div>

            {showPopup &&
                <section className="w-[100%] min-h-[100vh] flex-center fixed top-0 left-0 bg-[#000000b7] z-[99999999999]">
                    <button className="fixed top-[2vmax] right-[2vmax]"
                        onClick={() => setShowPopup(false)}
                    >
                        <i className="fa-solid fa-xmark text-white text-[2vmax]"></i>
                    </button>
                    <div className="bg-white rounded-xl  shadow-1 overflow-hidden w-[35%]">
                        <div className="font-3 font-[700] text-white bg-[image:var(--gradient-2)] py-[0.6vmax] text-center text-[1.5vmax]">
                            {popupHeading}
                        </div>
                        <p className='p-[1.5vmax] text-[1.1vmax] font-3  text-slate-700 whitespace-pre-line' >
                            {popupPara}
                        </p>
                        <div className="flex justify-end gap-[1.5vmax] p-[1.5vmax]">
                            {actionToPerform !== "HidePopup" &&
                                <button className="text-[1.1vmax] font-3 bg-gray-500 text-white 
                            p-[0.5vmax_1vmax] rounded-lg "
                                    onClick={() => {
                                        setShowPopup(false)
                                        setActionToPerform("")
                                    }}
                                >No</button>

                            }

                            <button className="text-[1.1vmax] font-3 bg-[image:var(--gradient-2)] text-white 
                            p-[0.5vmax_1vmax] rounded-lg"
                                onClick={handleReserve}
                            >Yes</button>
                        </div>
                    </div>
                </section>
            }
        </Fragment>
    )
}

export default SelectedProductButtons